document.addEventListener('DOMContentLoaded', function() {
    const menuContainer = document.querySelector('.header__inline-menu');

    if (menuContainer) {
        menuContainer.addEventListener('click', function(event) {
            const target = event.target.closest('details');
            if (!target) return;

            // Toggle the open attribute
            const isOpen = target.hasAttribute('open');
            target.toggleAttribute('open', !isOpen);

            // Update aria-expanded attribute
            const summary = target.querySelector('summary');
            if (summary) {
                summary.setAttribute('aria-expanded', !isOpen);
            }

            // Close other open dropdowns
            const items = menuContainer.querySelectorAll('details');
            items.forEach(item => {
                if (item !== target) {
                    item.removeAttribute('open');
                    const otherSummary = item.querySelector('summary');
                    if (otherSummary) {
                        otherSummary.setAttribute('aria-expanded', false);
                    }
                }
            });
        });
    }
});
